import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardChat } from "../../../../../state/dashboard/actions";
import {
  Header,
  ModuleContainer,
  IconContainer,
  IconStyle,
  ExtentionContainer,
  RefreshDeleteContainer,
  FilterLine,
  Report,
} from "./styles";
import { CircularProgress } from "@material-ui/core";
import {
  CustomRefreshIcon,
  CustomRemoveIcon,
  CustomAddIcon,
  CustomFilterIcon,
} from "../../styles";
import { BsFillChatLeftTextFill } from "react-icons/bs";
import IterableChatReport from "./IterableChatReport";
import Filters from "../../../../../components/FiltersforReports/Filters";

const LoadingIndicator = () => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <CircularProgress />
  </div>
);

const processChatData = (chatData, days) => {
  const currentTime = new Date();
  const pastHours = new Date(
    currentTime.getTime() - days * 24 * 60 * 60 * 1000
  );

  const groupedByRefId = chatData.reduce((groups, message) => {
    const messageTime = new Date(message.createdAt);
    if (messageTime >= pastHours) {
      const { refId } = message;
      if (!groups[refId]) {
        groups[refId] = [];
      }
      groups[refId].push(message);
    }
    return groups;
  }, {});

  const recentRefIds = Object.keys(groupedByRefId);

  const allChatsForRecentTasks = chatData.reduce((groups, message) => {
    if (recentRefIds.includes(message.refId)) {
      const { refId } = message;
      if (!groups[refId]) {
        groups[refId] = [];
      }
      groups[refId].push(message);
    }
    return groups;
  }, {});

  return allChatsForRecentTasks;
};

const getTasksFromGroupedData = (groupedData) => {
  return Object.keys(groupedData).map((refId) => {
    const firstMessage = groupedData[refId][0];
    return {
      taskLabel: firstMessage.taskLabel,
      flowTitle: firstMessage.flowTitle,
      flowDescription: firstMessage.flowDescription,
      messages: groupedData[refId],
      taskId: firstMessage.refId,
      taskStatus: firstMessage.taskStatus,
    };
  });
};

const renderControls = (
  isEditing,
  isExcluded,
  remove,
  restore,
  dispatch,
  fetchDashboardChat,
  toggleFilter
) => (
  <RefreshDeleteContainer>
    <CustomFilterIcon
      onClick={(e) => {
        e.stopPropagation();
        toggleFilter();
      }}
    />
    {isEditing ? (
      !isExcluded ? (
        <CustomRemoveIcon
          onClick={(e) => {
            e.stopPropagation();
            remove();
          }}
        />
      ) : (
        <CustomAddIcon
          onClick={(e) => {
            e.stopPropagation();
            restore();
          }}
        />
      )
    ) : (
      <CustomRefreshIcon
        onClick={(e) => {
          e.stopPropagation();
          dispatch(fetchDashboardChat());
        }}
      />
    )}
  </RefreshDeleteContainer>
);

const ChatReport = ({
  isExpanded,
  toggleExpand,
  isEditing,
  remove,
  restore,
  isExcluded,
}) => {
  const dispatch = useDispatch();
  const dashChat = useSelector((state) => state.dashboard.chatProductivity);
  const [finalGroupedByRefId, setFinalGroupedByRefId] = useState({});
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [days, setDays] = useState(7);
  const [filterOpen, setFilterOpen] = useState(false);
  const toggleFilter = () => {
    setFilterOpen(!filterOpen);
    if (filterOpen) {
      setSelectedTitle(null);
      setDays(7);
    }
  };

  useEffect(() => {
    if (dashChat.status === "succeeded") {
      const groupedData = processChatData(dashChat.data.chat, days);
      setFinalGroupedByRefId(groupedData);
    } else if (dashChat.status !== "succeeded") {
      dispatch(fetchDashboardChat());
    }
  }, [dashChat.status, dashChat.data.chat, days, dispatch]);

  const tasks = getTasksFromGroupedData(finalGroupedByRefId).filter(
    (task) => !selectedTitle || task.flowTitle === selectedTitle
  );

  if (dashChat.status === "loading" || dashChat.status === "failed") {
    return (
      <ModuleContainer>
        <Report>
          <Header>
            <IconContainer>
              <BsFillChatLeftTextFill style={IconStyle} />
            </IconContainer>
            {dashChat.status === "loading" ? (
              <LoadingIndicator />
            ) : (
              <div>Error loading chat data</div>
            )}
          </Header>
        </Report>
      </ModuleContainer>
    );
  }

  return (
    <ModuleContainer isEditing={isEditing}>
      <Report>
        <Header onClick={toggleExpand}>
          <IconContainer>
            <BsFillChatLeftTextFill style={IconStyle} />
          </IconContainer>
          {"Últimos comentários"}
          {renderControls(
            isEditing,
            isExcluded,
            remove,
            restore,
            dispatch,
            fetchDashboardChat,
            toggleFilter
          )}
        </Header>
        {filterOpen && ( // future FilterOpen
          <FilterLine>
            <Filters
              flowTitles={getTasksFromGroupedData(finalGroupedByRefId).map(
                (task) => task.flowTitle
              )}
              onTitleChange={setSelectedTitle}
              onDaysChange={setDays}
            />
          </FilterLine>
        )}
      </Report>
      {isExpanded && (
        <ExtentionContainer>
          {tasks.length > 0 ? (
            <IterableChatReport tasks={tasks} />
          ) : (
            "Nenhum comentário recente"
          )}
        </ExtentionContainer>
      )}
    </ModuleContainer>
  );
};

export default ChatReport;
